<template>
  <div class="after-sales">
    <xl-dialog
      :title="$t('design.order.designAdjustment') || '设计调整'"
      v-model="visible"
      width="566px"
      @close="close"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="add-photo">
        <xl-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-position="top"
          show-message
        >
          <xl-form-item prop="reason" :label="$t('调整原因')">
           <xl-checkbox-group v-model="form.reason">
              <xl-checkbox v-for="reason in refuseReasons" :key="reason.value" :label="reason.value">
                {{ reason.label }}
              </xl-checkbox>
            </xl-checkbox-group>
          </xl-form-item>
          <xl-form-item prop="note" :label="$t('补充描述') || '备注'">
            <xl-input
              v-model="form.note"
              type="textarea"
              :placeholder="$t('design.inputRemark') || '请输入备注内容'"
              show-word-limit
              maxlength="2000"
              rows="6"
            ></xl-input>
          </xl-form-item>
        </xl-form>
      </div>
      <template #footer>
        <div class="footer-button">
          <xl-button @click="close">{{$t('design.cancel') || '取消'}}</xl-button>
          <xl-button type="primary" @click="handleSubmit" :loading="!isSubmitting">{{$t('design.submit') || '提交'}}</xl-button>
        </div>
      </template>
    </xl-dialog>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import {
  XlDialog,
  XlButton,
  XlForm,
  XlFormItem,
  XlInput,
  XlMessage,
  XlCheckboxGroup,
  XlCheckbox
} from "@shining3d/ui-components";
import { cloneDeep } from "lodash";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import orderApi from "../../../api/order";
import router from "@/router";
import { useStore } from 'vuex';
import Bus from '../../../utils/bus.js';
import _get from 'lodash/get';

const $store = useStore();
const { $t } = useLang("@shining3d/xl-design-order");
const route = router.currentRoute.value;
// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
const visible = ref(false);
const close = () => {
  visible.value = false;
};
const show = () => {
  visible.value = true;
};
const isSubmitting = ref( true );
//
const initInfo = {
  note: "",
};
const form = ref(cloneDeep(initInfo));
const formRef = ref();
const rules = {
  reason: [{ required: true, message: $t('请选择调整原因'), trigger: "blur" }],
};

const refuseReasons = [
	{ label: $t( 'design.refuseReason.originalFileMissing' ), value: 'originalFileMissing' },
	{ label: $t( 'design.refuseReason.invalidParameter' ), value: 'invalidParameter' },
	{ label: $t( 'design.refuseReason.redesignUnable' ), value: 'redesignUnable' },
	{ label: $t( 'design.refuseReason.other' ), value: 'other' }
];
// 提交设计调整
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    if(valid){
      orderApi.dentalxRejectTransferOrderDesign({
        reason: form.value.reason.join(','),
        note: form.value.note,
        id: route?.params?.id,
      }).then((res) => {
        if( res && res.status === 'success'){
          XlMessage({ type: 'success', message: $t('design.order.adjustDesignSuccess') || '调整设计成功' });
          Bus.$emit( 'updateOrderList' )
          visible.value = false;
          router.push({name: 'Design'});
        } else {
          visible.value = false;
        }
      });
    }
  })
};
defineExpose({ show });
</script>

<style lang="scss" scoped>
.after-sales {
  font-family: 'Alibaba PuHuiTi 2.0';
  .add-photo {
    .email-width {
      width: 664px;
      min-width: 664px;
    }
  }
  :deep(.xl-upload .el-upload-list--picture-card .el-upload-list__item){
    width: 104px;
    height: 104px;
    margin: 0 16px 16px 0 !important;
    .el-progress-circle{
        height: 102px !important;
        width: 102px !important;
    }
  }
  :deep(.xl-upload .el-upload--picture-card){
    width: 104px;
    height: 104px;
    margin-bottom: 16px !important;
    .icon{
        width: 40px !important;
        height: 40px !important;
        margin-top: 12px !important;
    }
  }
  :deep(.xl-upload .el-upload__text){
    margin-top: 0 !important;
    text-wrap: nowrap;
  }
    :deep(.el-progress){
        width: 102px !important;
    }
    :deep(.xl-upload .el-upload__tip){
        margin-top: -16px !important;
    }
    :deep(.el-form-item .el-form-item__label){
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: #42526E;
    }
}
</style>
